import { Alert, CardContent, CardMedia, Container } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
// import { DefaultLogo, WhiteLogo } from '../../../../constants/images';
import { DefaultLogo } from '../../../../constants/images';
import Loading from '../../../../Loading';
import { SITE_NAME_ABBR } from '../../constants/constants';
import fetchUpFile from '../../functions/fetchUpFile';
import PageHeader from '../PageHeader/PageHeader';

const MaintenancePage = ({ children }) => {
  // const theme = useTheme();
  // const isDark = theme.palette.mode === 'dark';
  // const logo = isDark ? WhiteLogo : DefaultLogo;
  const logo = DefaultLogo;
  const [isUp, setIsUp] = useState(false);
  useEffect(() => {
    let mount = true;
    if (mount && !isUp) {
      const fetch = async () => {
        setIsUp(await fetchUpFile());
      };
      fetch();
    }
    return () => {
      mount = false;
    };
  }, [isUp]);

  if (!isUp)
    return (
      <Loading active={isUp} fullscreen>
        Checking for site maintenance...
      </Loading>
    );
  if (isUp.response && isUp.response.status === 200) return <>{children}</>;

  return (
    <div>
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Container>
          <PageHeader title={`${SITE_NAME_ABBR} is down for Maintenance`} />
          <CardMedia>
            <div style={{ textAlign: 'center' }}>
              <img
                src={logo}
                style={{ height: '150px', margin: '15px' }}
                alt="Logo"
              />
            </div>
          </CardMedia>
          <CardContent>
            <Alert severity="warning">
              {SITE_NAME_ABBR} is down for maintenance or development. Please
              check back later.
            </Alert>
          </CardContent>
        </Container>
      </div>
    </div>
  );
};

MaintenancePage.propTypes = {
  children: PropTypes.object,
};

MaintenancePage.defaultProps = {
  children: {},
};

export default MaintenancePage;
